/**
 * Client-side cleanup when the user completes passkey registration from onboarding.
 * (Server popup-status / credentials are the source of truth for showing the promo.)
 */

export function clearPasskeyPromptFromStoredUser() {
    const raw = localStorage.getItem('user');
    if (!raw) return;
    try {
        const u = JSON.parse(raw);
        if (!u || !u.id) return;
        if (u.showPasskeyOnboarding) {
            u.showPasskeyOnboarding = false;
            localStorage.setItem('user', JSON.stringify(u));
        }
    } catch {
        /* ignore */
    }
}
